// components/course/OwnedCourseCard.jsx
// Owned course card, extracted verbatim from CoursesPage's renderOwnedCard so
// /courses and /library render the same card. Purely presentational: every
// value, including the meta line, arrives as a prop.

const C = {
  border: "rgba(28,26,23,0.11)",
  green: "#16a34a",
  text: "#18181b",
  textMuted: "#71717a",
};

// The card's CSS travels with the card. Pages render this once inside their
// own <style> block, matching this codebase's page-owns-its-styles convention.
export const OWNED_CARD_CSS = `
  .occ-card{background:#fff;border:0.5px solid ${C.border};border-radius:12px;padding:28px;display:flex;flex-direction:column;transition:border-color .2s;}
  .occ-card:hover{border-color:rgba(28,26,23,0.4);}
  .occ-cta{font-family:'Space Mono',monospace;font-size:12px;letter-spacing:0.04em;color:#fff;border:none;padding:11px 20px;border-radius:8px;cursor:pointer;transition:opacity .2s;flex-shrink:0;}
  .occ-cta:hover{opacity:0.85;}
`;

export default function OwnedCourseCard({
  accent,
  badge,
  title,
  desc,
  meta,
  ctaColor,
  onContinue,
}) {
  return (
    <div className="occ-card">
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
        <span style={{ width: 9, height: 9, background: accent, borderRadius: 2, flexShrink: 0 }} />
        <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: accent }}>
          {badge}
        </span>
        <span style={{ marginLeft: "auto", display: "inline-flex", alignItems: "center", gap: 6, fontFamily: "'Space Mono', monospace", fontSize: 11, fontWeight: 700, color: C.green }}>
          ✓ Owned
        </span>
      </div>
      <div style={{ fontFamily: "'Fraunces', Georgia, serif", fontSize: 27, fontWeight: 700, lineHeight: 1.2, color: C.text, marginBottom: 10 }}>
        {title}
      </div>
      <p style={{ margin: "0 0 16px", fontSize: 14, fontWeight: 300, lineHeight: 1.7, color: C.textMuted }}>
        {desc}
      </p>
      <div style={{ marginTop: "auto" }}>
        <div style={{ fontSize: 13, color: C.textMuted, paddingBottom: 16, borderBottom: `0.5px solid ${C.border}` }}>
          {meta}
        </div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", paddingTop: 16 }}>
          <button className="occ-cta" onClick={onContinue} style={{ background: ctaColor }}>
            Continue →
          </button>
        </div>
      </div>
    </div>
  );
}
